import { AssetType } from '@nemuru-eng/js-api-client';
import { z } from 'zod';

import { GetTextIdTranslationType } from '@/components/shared/hooks/useTranslation';
import { requiredEnum } from '@/utils/zodUtils';

export const ConsumerLoanDetailsFormSchema = (t: GetTextIdTranslationType) =>
  z
    .object({
      type: requiredEnum(AssetType, t),
      description: z.string().nullable(),
    })
    .strict();

export type ConsumerLoanDetailsFormType = z.infer<ReturnType<typeof ConsumerLoanDetailsFormSchema>>;
